import swal from "sweetalert";
import { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Box, Button, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useDispatch, useSelector } from "react-redux";
import UnitsAndEnumsModal from "./UnitsAndEnumsModal";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { useNavigate } from "react-router-dom";
import { closeEnumsDialog, openEnumsDialog } from "../state/enums/actions";
import { addNewEnumsFile } from "../api/enumsapi";
ModuleRegistry.registerModules([AllCommunityModule]);

const EnumsGrid = ({result}) => {
  
  const [rowData, setRowData]    =  useState([]);
  const navigate                 =  useNavigate();
  const dispatch                 =  useDispatch();
  const [formModalData, setFormModalData] = useState({
    releaseNotes:'',
    fileName: '',
    isLatest: false
  });
  const enumsDialogBoxStatus  = useSelector((state) => state.enumData.isEnumsDialogOpen);


  useEffect(() => { 
    const formatTableData = () => { 
      let rows = [];
      result.forEach((parent) => {
        rows.push({
          parentId: parent.id,
          childId: null,
          groupNameLabel: parent.groupNameLabel,
          isParent: true,
          isNew: parent.isNew || false
        });
        parent.values.forEach((child) => {
          rows.push({
            parentId: parent.id,
            childId: child.id,
            label: child.label,
            isParent: false,
            isNew: child.isNew || false
          });
        });
        return rows;
      });
      setRowData(rows);
    }
    formatTableData();
  },[result]);

  const columnDefs = [
    {
      field: "parentId",
      headerName: "ID",
      width: 150,
      valueGetter: (p) => (p.data.isParent ? p.data.parentId : ""),
      resizable: false,
      sortable: false
    },
    
    {
      field: "groupNameLabel",
      headerName: "Group Name",
      editable: (params) => params.data.isParent,
      width: 360,
      resizable: false,
      sortable: false
    },
    {
      field: "childId",
      headerName: "Label ID",
      width: 145,
      valueGetter: (p) => (!p.data.isParent ? p.data.childId : ""),
      resizable: false,
      sortable: false
    },
    {
      field: "label",
      headerName: "Label",
      editable: (params) => !params.data.isParent,
      width: 360,
      resizable: false,
      sortable: false
    },
    {
      headerName: "Actions",
      width: 200,
      resizable: false,
      sortable: false,
      cellRenderer: (params) => {
        if (params.data.isParent) {
          return (
            <div>
              <Tooltip title="Add new label">
                <AddCircleIcon
                  onClick={() => addChild(params.data.parentId)}
                  sx={{ cursor: "pointer", mr: 1 }}
                  fontSize="small"
                />
              </Tooltip>
              {params.data.isNew && (
                <Tooltip title="Delete Group Name">
                  <DeleteIcon
                    onClick={() => handleDelete(params.node)}
                    color="error"
                    sx={{ cursor: "pointer" }}
                    fontSize="small"
                  />
                </Tooltip>
              )}
            </div>
          );
        } else if (params.data.isNew) {
          return (
            <Tooltip title="Delete Label">
              <DeleteIcon
                onClick={() => handleDelete(params.node)}
                color="error"
                sx={{ cursor: "pointer" }}
                fontSize="small"
              />
            </Tooltip>
          );
        }
        return null;
      }
    }
  ];

  const handleDelete = (node) => {
    setRowData((prev) =>
      reorderIds(
        prev.filter((r) => {
          if (node.data.isParent) {
            // deleting a parent, remove parent + all its children
            return r.parentId !== node.data.parentId;
          } else {
            // deleting a child, only remove that child
            return !(
              r.parentId === node.data.parentId &&
              r.childId === node.data.childId
            );
          }
        })
      )
    );
  }

  const addChild = (parentId) => {
      const parentChildren = rowData.filter(
        (r) => !r.isParent && r.parentId === parentId
      );
      const newChildId = getNextId(parentChildren, "childId");
      const newChild = {
        parentId,
        childId: newChildId,
        label: "",
        isParent: false,
        isNew: true
      };

      let insertIndex = null;

      if (parentChildren.length > 0) {
      // Insert after last existing child
        insertIndex = rowData.reduceRight((acc, r, idx) => {
          if (!acc && !r.isParent && r.parentId === parentId) return idx + 1;
          return acc;
        }, null);
      } else {
        // Insert right after the parent
        insertIndex = rowData.findIndex(
          (r) => r.isParent && r.parentId === parentId
        ) + 1;
      }
      const newRows = [...rowData];
      newRows.splice(insertIndex, 0, newChild);
      setRowData(reorderIds(newRows));
    };

  const addParent = () => {
    const newParentId = getNextId(
      rowData.filter(r => r.isParent),
      "parentId"
    );
    const newParent = {
      parentId: newParentId,
      childId: null,
      groupNameLabel: "",
      isParent: true,
      isNew: true
    };
    setRowData((prev) => reorderIds([...prev, newParent]));
  };

  const formatDataBeforeSave = (rows) => {
    const parents = rows.filter((r) => r.isParent);
    const children = rows.filter((r) => !r.isParent);
    return parents.map((p) => {
      const vals = children
        .filter((c) => c.parentId === p.parentId)
        .map((c) => ({
          id: c.childId,
          label: c.label
        }));

      return {
        id: p.parentId,
        groupNameLabel: p.groupNameLabel,
        values: vals
      };
    });
  };

  const handleSave = () => {
    if(formModalData.length === 0 || formModalData.fileName === '' || formModalData.releaseNotes === ''){
      swal("Oops!", "Please fill required fields!", "error");
      return false;
    }
    const formatedData = formatDataBeforeSave(rowData);
    const formData = new FormData(); 
    formData.append('fileContent', new Blob([JSON.stringify(formatedData)],{type:'application/json'}),'fileContent.txt');
    formData.append('fileName',formModalData.fileName)
    formData.append('releaseNotes',formModalData.releaseNotes);
    formData.append('isLatest',formModalData.isLatest);
    dispatch(addNewEnumsFile(formData));
    dispatch(closeEnumsDialog());
    handleGoBack();
  };

  const getNextId = (items, key) => {
    if (!items || items.length === 0) return 0;
    const maxId = Math.max(...items.map((i) => i[key] ?? 0));
    return maxId + 1;
  };

  const reorderIds = (rows) => {
    let parents = rows.filter(r => r.isParent);
    // Reorder parent IDs
    parents.forEach((p, index) => {
      const oldParentId = p.parentId;
      const newParentId = index;
      // Update parent
      p.parentId = newParentId;

      // Update all children belonging to this parent
      rows
        .filter(c => !c.isParent && c.parentId === oldParentId)
        .forEach(c => (c.parentId = newParentId));
    });

    // Reorder child IDs inside each parent
    parents.forEach((p) => {
      const children = rows.filter(c => !c.isParent && c.parentId === p.parentId);
      children.forEach((c, idx) => (c.childId = idx));
    });

    return [...rows];
  };

  const handleGoBack = () => {
    navigate('/web/enums');
  };

  const handleClickOpenRole = () => {
    document.activeElement.blur(); 
    dispatch(openEnumsDialog());
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{paddingBottom:2}}>
          <Button onClick={handleGoBack} variant="contained">Back</Button>
          <Box display="flex" gap={2}> 
              <Button variant="contained" color="secondary" onClick={addParent}> Add Parent Row </Button>
              <Button variant="contained" sx={{ ml: 2 }} onClick={handleClickOpenRole} > Create </Button>
          </Box>
      </Box>
      <div style={{ width: "100%", height: "500px" }}>
        <AgGridReact
          stopEditingWhenCellsLoseFocus={true}
          rowData={rowData}
          columnDefs={columnDefs}
          suppressMovableColumns={true}
          animateRows={true}
          getRowId={(params) =>
            params.data.isParent
              ? `parent-${params.data.parentId}`
              : `child-${params.data.parentId}-${params.data.childId}`
          }
        />
      </div>
      <UnitsAndEnumsModal 
          title={"Enums New File"}
          open={enumsDialogBoxStatus || false}
          value={formModalData}
          setFormModalData={setFormModalData}
          handleSave={handleSave}
      />
    </>
  );
};

export default EnumsGrid;
